import React from 'react';
import { useTranslation } from 'react-i18next';
import Container from '@material-ui/core/Container';
import { baseUrl } from '../../config/baseUrl';
import {
  StyledTitle,
  StyledListItem,
  StyledLink,
  StyledImageContainer,
  StyledImage,
  StyledQrImage,
} from './UserManual.styled';
import { MainLayout } from '../../layouts';

const UserManual = (props) => {
  const { t } = useTranslation();
  return (
    <MainLayout>
      <Container>
        <StyledTitle>{t('ManualTitle')}</StyledTitle>
        <StyledImageContainer>
          <StyledQrImage>
            <img
              src={`${baseUrl}img/mobile-app/qr_utraffic_download.png`}
              alt='QR Code'
            />
            <small>{t('ScanDownload')}</small>
          </StyledQrImage>
        </StyledImageContainer>
        <ol>
          <StyledListItem>
            <p>
              {t('InstallApp1')}{' '}
              <StyledLink
                href='https://play.google.com/store/apps/details?id=com.hcmut.daipham.bktrafficsystem'
                alt='#'
                target='_blank'
                rel='noreferrer'
              >
                https://play.google.com/store/apps/details?id=com.hcmut.daipham.bktrafficsystem
              </StyledLink>{' '}
              {t('InstallApp2')}
            </p>
            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/1-app-chplay.png`}
                atl='CH play'
              />
            </StyledImageContainer>
          </StyledListItem>
          <StyledListItem>
            <p>{t('Login')}</p>

            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/2-login.png`}
                atl='login screen'
              />
            </StyledImageContainer>
          </StyledListItem>
          <StyledListItem>
            <p>{t('Register')}</p>

            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/3-register.jpeg`}
                atl='register screen'
              />
            </StyledImageContainer>
          </StyledListItem>
          <StyledListItem>
            <p>{t('MainScreen')}</p>

            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/4.1-traffic-report.png`}
                atl='main screen'
              />
            </StyledImageContainer>
            <p>
              {t('TrafficStatusInfo')}
              {' "DỮ LIỆU"'}
            </p>

            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/4.2-no-traffic-report.png`}
                atl='no traffic report'
              />
            </StyledImageContainer>
          </StyledListItem>
          <StyledListItem>
            <p>{t('Search')}</p>
            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/5-search-area.png`}
                atl='search-area'
              />
            </StyledImageContainer>
          </StyledListItem>
          <StyledListItem>
            <p>{t('Menu')}</p>
            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/6.1-menu.png`}
                atl='menu'
              />
            </StyledImageContainer>
            <p>{t('RewardDisplay')}</p>
            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/6.2-point.png`}
                atl='point'
              />
            </StyledImageContainer>
          </StyledListItem>
          <StyledListItem>
            <p>
              {t('ChangePoint1')}
              <strong>Tài khoản → Quản Lý Voucher</strong>
              {t('ChangePoint2')}
            </p>
            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/7-reward.png`}
                atl='reward'
              />
            </StyledImageContainer>
          </StyledListItem>
          <StyledListItem>
            <p>
              {t('SelectCard')} <strong> Đổi</strong>
            </p>
            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/8-change-point.png`}
                atl='change-point'
              />
            </StyledImageContainer>
          </StyledListItem>
          <StyledListItem>
            <p>
              {t('Payment')} <strong> Thanh toán</strong>
            </p>
            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/9-payment.png`}
                atl='payment'
              />
            </StyledImageContainer>
          </StyledListItem>
          <StyledListItem>
            <p>
              {t('ViewVoucher1')} <strong> Tài khoản</strong>{' '}
              {t('ViewVoucher2')}{' '}
              <img
                src={`${baseUrl}img/mobile-app/button.png`}
                alt='button'
                style={{ width: 24, height: 24 }}
              />{' '}
              {t('ViewVoucher3')} <strong>Voucher của tôi</strong>
            </p>
            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/10-my-voucher.png`}
                atl='my-voucher'
              />
            </StyledImageContainer>
          </StyledListItem>
          <StyledListItem>
            <p>{t('ViewCode')}</p>
            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/11-card.png`}
                atl='card'
              />
            </StyledImageContainer>
          </StyledListItem>
          <StyledListItem>
            <p>
              {t('CheckVersion')}
              <strong> Tài khoản → Thông tin liên hệ và góp ý.</strong>{' '}
            </p>
            <StyledImageContainer>
              <StyledImage
                src={`${baseUrl}img/mobile-app/12-feedback.png`}
                atl='feedback'
              />
            </StyledImageContainer>
          </StyledListItem>
        </ol>
      </Container>
    </MainLayout>
  );
};

export default UserManual;
